<template>
  <div class="home">
   <Toast />
    <div>
      <div v-if="errorLogin == null">

          <div class="seccion-titulo">
              {{ $t('menu_solicitardiploma', {textoDiploma: $parent.getTextoDiploma}) }}
          </div>   
          <div class="seccion-parrafo-nivel-1">
              {{ $t('soldip_solicite', {textoDiplomas: $parent.getTextoDiplomas, textoDiploma: $parent.getTextoDiploma}) }}
          </div> 
          <div class="seccion-parrafo-nivel-2">
              {{ $t('soldip_infosolicitud', {nombreApp: $parent.getNombreApp}) }} 
              <br/>
              {{ $t('soldip_pasos', {textoDiploma: $parent.getTextoDiploma}) }}
              <ol>
                <li>{{ $t('soldip_paso1') }}</li>
                <li>{{ $t('soldip_paso2', {textoDiploma: $parent.getTextoDiploma, nombreApp: $parent.getNombreApp, emailApp: $parent.getEmailApp}) }}</li>
                <li>{{ $t('soldip_paso3', {textoDiploma: $parent.getTextoDiploma}) }}</li>
                <!-- <li>{{ $t('soldip_paso4', {textoDiploma: $parent.getTextoDiploma}) }}</li> -->
              </ol>
              
              {{ $t('soldip_condiciones') }}
              <ol>
                <li>{{ $t('soldip_condicion1', {textoDiploma: $parent.getTextoDiploma}) }} </li>
                <li>{{ $t('soldip_condicion2') }}</li>
                <li>{{ $t('soldip_condicion3') }}</li>
                <!-- <li>{{ $t('soldip_condicion4', {nombreApp: $parent.getNombreApp}) }}  (<a :href="'mailto:' + $parent.getEmailApp">{{$parent.getEmailApp}}</a>)</li> -->
              </ol>
          </div>    
          <div class="seccion-subtitulo" id="contenidoPrincipal">
              {{ $t('soldip_solicita', {textoDiploma: $parent.getTextoDiploma}) }}
          </div>  

          <div class="msg-info" v-if="diplomaGeneradoOk"> 
            <div class="msg-info-title"> 
              {{ $t('soldip_puedevisua', {textoDiploma: $parent.getTextoDiploma}) }}: 
              <a href="#" @click="$router.push('/diplomas')">  
                {{ $t('menu_diplomas', {textoDiplomas: $parent.getTextoDiplomas}) }} 
              </a> 
            </div>
          </div>
  
          <div class="seccion-contenido">

            <div class="msg-warn" v-if="previsualizadoError && !displayModalDatosEstudiante">
              <div class="msg-warn-title">
                <strong> {{ $t('soldip_comprobar', {textoDiploma: $parent.getTextoDiploma}) }}: </strong>
                <br/>
                <div v-if="datosEstudianteErrorSolicitaCambio">  {{ $t('error_datos_estudiante_cambioOK', {emailEstudiante: $parent.getEmailEstudiante, nombreApp: $parent.getNombreApp}) }}  </div>
                <div v-if="!datosEstudianteErrorSolicitaCambio"> {{ $t('error_datos_estudiante_cambioKO', {textoDiploma: $parent.getTextoDiploma})}} </div>          
              </div>
            </div>

            <div v-if="actividades.length > 0">
            <DataTable :value="actividades" dataKey="codigo">                  
                  <Column field="actividad" v-bind:header="$t('soldip_actividad')" :sortable="true" sortField="titulo">
                    <template #body="slotProps">
                      {{ slotProps.data.actividad }}  
                      <br />
                      <small> ({{ new Date(slotProps.data.fechaini) | dateFormat('DD/MM/YYYY') }} - {{ new Date(slotProps.data.fechafin) | dateFormat('DD/MM/YYYY') }})</small>
                      <span v-if="$parent.isAdmin && slotProps.data.antiguo == 'S'">
                        <br/>
                        <small class="remarcado">{{ $t('diploma_papel') }}</small>
                      </span>
                      <span v-if="slotProps.data.errorPendienteDatos == 'S'">
                        <br/>
                        <small class="remarcado">{{ $t('error_datos_estudiante_bloqueo', {textoDiploma: $parent.getTextoDiploma, nombreApp: $parent.getNombreApp}) }}</small>
                      </span>  
                    </template>  
                  </Column>
                  <Column header="" :exportable="false" headerStyle="width: 40%; text-align:center;" bodyStyle="text-align:center;"  >  
                    <template #body="slotProps">
                      <Button v-bind:label="$t('soldip_previsualizar')"  icon="pi pi-eye" :disabled="slotProps.data.errorPendienteDatos == 'S'" class="p-button-danger p-m-2" @click="openModalPrevisualizar(slotProps.data)" />                
                      <Button v-bind:label="$t('soldip_generar')" icon="pi pi-file-pdf" :disabled=!slotProps.data.previsualizadoOk class="p-button-danger p-m-2" @click="openModalGenerar(slotProps.data)" />
                    </template>
                  </Column>
                   
                </DataTable>

            </div>   
              <div v-else>
                <div v-if="!diplomaGeneradoOk">
                  <div class="msg-warn">
                    <div class="msg-warn-title">
                      {{ $t('soldip_empty', {textoDiploma: $parent.getTextoDiploma}) }}
                    </div>
                  </div>
                  </div>
                </div>
              
              <Dialog v-bind:header="$t('soldip_previsualizacion', {textoDiploma: $parent.getTextoDiploma})" :visible.sync="displayModalPrevisualizar" :style="{width: '80vw'}" :modal="true">
                      <p class="p-m-0 seccion-contenido-left">
                          {{ $t('soldip_borrador', {textoDiploma: $parent.getTextoDiploma, nombreApp: $parent.getNombreApp}) }}
                      </p>
                      <br/>
                      <!-- El visor del pdf borrador -->
                      <div class="visor-pdf">
                        <div v-if="!borradorData.data">
                            <i class="pi pi-spin pi-spinner" style="fontSize: 2rem"></i>
                            <br/>
                            <i>{{ $t('soldip_previsualiza') }}</i>
                        </div>
                        <pdf class="visor-pdf-borrador" v-if="borradorData.data"
                            v-for="i in numPages"
                            :key="i"
                            :src="borradorData"
                            :page="i"
                        ></pdf>

                      </div>
                      <!-- Fin del visor del pdf borrador -->
                      <template #footer>
                          <p>{{ $t('soldip_dipcorrecto', {textoDiploma: $parent.getTextoDiploma}) }}</p>
                          <Button label="No" icon="pi pi-times" @click="marcaDatosKO" v-bind:disabled="!borradorData.data" class="p-button-text p-button-danger"/>
                          <Button v-bind:label="$t('si')" icon="pi pi-check" @click="marcaDatosOK" v-bind:disabled="!borradorData.data" autofocus class="p-button-danger" />
                      </template>
                  </Dialog>    

              <Dialog v-bind:header="$t('soldip_generando', {textoDiploma: $parent.getTextoDiploma})" :visible.sync="displayModalGenerar" :style="{width: '50vw'}" :modal="true" :dismissableMask="false" :closeOnEscape="false" :closable="false">
                  <p class="p-m-0 seccion-contenido-left">
                      {{ $t('soldip_generarconfirma', {textoDiploma: $parent.getTextoDiploma}) }}
                  </p>
                  <br/>
                  <div v-if="generandoDiploma" class="seccion-contenido-centro">
                      <i class="pi pi-spin pi-spinner" style="fontSize: 2rem"></i>
                      <br/>
                      <i>{{ $t('soldip_generando', {textoDiploma: $parent.getTextoDiploma}) }}</i>
                  </div>

                  <template #footer v-if="!generandoDiploma">
                      <Button label="No" icon="pi pi-times" @click="closeModalGenerar" class="p-button-text p-button-danger"/>
                      <Button v-bind:label="$t('si')" icon="pi pi-check" @click="generacion" autofocus class="p-button-danger" />
                  </template>
              </Dialog>

              <!-- CURSOS-1152 -->
              <Dialog v-bind:header="$t('error_datos_estudiante', {textoDiploma: $parent.getTextoDiploma})"  :visible.sync="displayModalDatosEstudiante" :style="{width: '50vw'}" :modal="true" :dismissableMask="false" :closeOnEscape="false" :closable="false">
                  <p class="p-m-0 seccion-contenido-left">
                    {{ $t('error_datos_estudiante_head', {textoDiploma: $parent.getTextoDiploma}) }}
                    <br/>
                    <br/>

                      <label for="errorDatosEstudiante">{{ $t('error_datos_estudiante_detalle') }} </label>
                      <br/>
                      <Textarea
                        type="text"
                        style="margin-top:5px;"
                        id="errorDatosEstudiante"
                        name="errorDatosEstudiante"
                        v-model="errorDatosEstudiante"
                        :class="{ 'p-invalid' : this.obligatorioErrorDatosEstudiante == true}"
                        rows="2" cols="70"
                        :autoResize="true"
                        :maxlength=4000
                        autofocus
                      />
                      <div v-if="this.errorDatosEstudiante != null" class="p-m-0 seccion-contenido-left">
                        ({{this.errorDatosEstudiante.length}}/4000)
                      </div>
                  </p>
                      
                      <fichero-diploma-error :fichero="fichero"/>
                  
                  <br/>
                  {{ $t('error_datos_estudiante_continuar') }}
                  
                  <template #footer v-if="!generandoDiploma">
                      <Button label="No" icon="pi pi-times" @click="closeModalDatosEstudiante" class="p-button-text p-button-danger"/>
                      <Button v-bind:label="$t('si')" icon="pi pi-check" @click="openModalGuardarDatos" class="p-button-danger" />
                  </template>
              </Dialog>      

              <Dialog v-bind:header="$t('error_datos_estudiante_antes_guardar')"  :visible.sync="displayModalGuardarDatos" :style="{width: '50vw'}" :modal="true" :dismissableMask="false" :closeOnEscape="false" :closable="false">
                  <div v-if="fichero.nombreFichero == null" class="seccion-contenido-centro">
                      <br/>
                      {{ $t('error_datos_estudiante_sin_adjuntos', {nombreApp: $parent.getNombreApp}) }}
                  </div>
                  <div v-if="fichero.nombreFichero != null" class="seccion-contenido-centro">
                      <br/> 
                      {{ $t('error_datos_estudiante_confirma_guardar', {nombreApp: $parent.getNombreApp}) }}
                  </div>

                  <template #footer>
                      <Button label="No" icon="pi pi-times" @click="closeModalGuardarDatos" class="p-button-text p-button-danger"/>
                      <Button v-bind:label="$t('si')" icon="pi pi-check" @click="guardarDatosEstudiante()" autofocus class="p-button-danger" />
                  </template>
              </Dialog>

           </div>
          
      </div>   

    </div>
    <div v-if="errorLogin != null">
      <div class="msg-warn">
        <div class="msg-warn-title">
            {{ $t('err_acceso') }}
            <br/>
            <span @click="$parent.logoutSession()" class="enlace-span">
                {{ $t('err_url') }}
            </span>
          </div>
        
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import ServicioRest from "@/services/ServicioRest";
import Dialog from "primevue/dialog";
import pdf from "vue-pdf";
import Toast from "primevue/toast";
import store from "../store";
import pdfUtil from "@/util/pdfUtil.js";
import Textarea from "primevue/textarea";
import FicheroDiplomaError from "../components/diploma/FicheroDiplomaError.vue";

export default {
  name: "Home",

  data() {
    return {
      actividades: [],
      displayModalPrevisualizar: false,
      borradorData: {
        data: null,
      },
      recargar: 0,
      displayModalGenerar: false,
      generandoDiploma: false,
      numPages: undefined,
      errorLogin: null,
      filaPrevisualizada: null,
      diplomaGeneradoOk: false,
      previsualizadoError: false,
      filaToGenerar: null,
      //CURSOS-1152
      displayModalDatosEstudiante: false,
      displayModalGuardarDatos: false,
      obligatorioErrorDatosEstudiante: false,
      datosEstudianteErrorSolicitaCambio: false,
      errorDatosEstudiante: null,
      fichero: {
        nombreFichero: null,
        fileContent: null,
      },
      contadorRepeticionesBack: 0,
    };
  },
  servicioRest: null,
  created() {
    this.servicioRest = new ServicioRest();

    // Accedemos al getter poniendo especificando el módulo / getter
    let token = store.getters["token/getToken"];
    this.servicioRest.actividadesAlumno(token).then((response) => {
      if (response.status == 'OK') {
        this.actividades = response.actividades;
      }
    }).catch((error) => {
        this.errorLogin = "El usuario o clave introducidos son incorrectos";
    });
  },
  methods: {
    cargarActividades() {
      let token = store.getters["token/getToken"];
      this.servicioRest.actividadesAlumno(token).then((response) => {
        if (response.status == 'OK') {
          this.actividades = response.actividades;
        }
      }).catch((error) => {
          this.errorLogin = "El usuario o clave introducidos son incorrectos";
      });
    },
    openModalPrevisualizar(value) {
      this.borradorData.data = null;
      this.generandoDiploma = true;
      this.diplomaGeneradoOk = false;
      this.displayModalPrevisualizar = true;
      let token = store.getters["token/getToken"];
      this.servicioRest
        .previsualizacion(value.cucod, token)
        .then((response) => {
          if (response.status == 'OK') {
            this.diplomaPdf = pdfUtil.base64DecToArr(
              response.diplomaPdf
            ).buffer;
            this.borradorData.data = this.diplomaPdf;
            this.recargar++;
            // CURSOS-1114
            this.numPages = response.numPagesReport;
            this.generandoDiploma = false;
            this.filaPrevisualizada = value;
            this.diplomaGenerado = false;
          }
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('soldip_previewerror'), life: 3000 });
      });
    },
    closeModalPrevisualizar() {
      this.displayModalPrevisualizar = false;
    },
    openModalGenerar(value) {
      this.filaToGenerar = value;
      this.displayModalGenerar = true;
    },
    closeModalGenerar() {
      this.filaToGenerar = null;
      this.displayModalGenerar = false;
    },
    openModalDatosEstudiante() {
      this.errorDatosEstudiante = null;
      this.obligatorioErrorDatosEstudiante = false;
      this.datosEstudianteErrorSolicitaCambio = false;
      this.fichero = {
        nombreFichero: null,
        fileContent: null,
      };
      this.displayModalDatosEstudiante = true;
    },
    closeModalDatosEstudiante() {
      this.displayModalDatosEstudiante = false;
    },
    openModalGuardarDatos() {
      if (
        this.errorDatosEstudiante === null ||
        this.errorDatosEstudiante.length <= 0
      ) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("warn"),
          detail: this.$t("error_datos_estudiante_detalle"),
          life: 3000,
        });
        this.obligatorioErrorDatosEstudiante = true;
        return;
      }
        this.displayModalGuardarDatos = true;
    },
    closeModalGuardarDatos() {
      this.displayModalGuardarDatos = false;
    },

    generacion() {
      this.generandoDiploma = true;
      let token = store.getters["token/getToken"];
      var diplomaContext = {
        cursosDiplomas: {
          id: {
            cuCod: this.filaToGenerar.cucod,
            identificador: this.filaToGenerar.identificador,
          },
          estado: "G",
          userSolicita: this.filaToGenerar.identificador,
          fechaSolicita: new Date(),
        },
        pidDocumento: null,
      };

      this.servicioRest.generacion(diplomaContext, token).then((response) => {
        this.obtenerResolucion(response.idProcesoBack, token);
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('soldip_generarerror'), life: 3000 });
      });
    },
    obtenerResolucion(numSolicitud, token) {
      this.servicioRest.obtenerResolucion(numSolicitud, token).then((response) => {
          if(!response.procesoBackTerminado){
            this.contadorRepeticionesBack = this.contadorRepeticionesBack + 1;
            if (this.contadorRepeticionesBack >= 9){ //si se superan los 40s marcamos un error
              this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("soldip_diperror", {
                  textoDiploma: this.$parent.getTextoDiploma,
                }),
                life: 3000,
              });

              //desbloqueamos
              this.generandoDiploma = false;
              this.closeModalGenerar();
              this.filaToGenerar = null;
              this.contadorRepeticionesBack = 0;

            } else{
              // Esperamos para volver a hacer la petición, en este caso 5000ms, 5s, le ponemos tiempo de espera que queramos
              setTimeout(()=>{this.obtenerResolucion(numSolicitud, token)}, 5000);
            }

          } else { //terminado
            // Procesamiento de los datos ya obtenidos
            this.generandoDiploma = false;
            this.closeModalGenerar();
            this.filaToGenerar = null;
            this.contadorRepeticionesBack = 0;

            this.$toast.add({
              severity: "success",
              summary: this.$t("soldip_dipgenerado", {
                textoDiploma: this.$parent.getTextoDiploma,
              }),
              detail: this.$t("soldip_dipok", {
                textoDiploma: this.$parent.getTextoDiploma,
              }),
              life: 3000,
            });
            this.$router.push({ name: "SolicitarDiploma" }),
              (this.diplomaGeneradoOk = true);
            this.cargarActividades();
          }
        })
        // Si se produce un error
        .catch(() => {
            this.generandoDiploma = false;
            this.closeModalGenerar();
            this.filaToGenerar = null;
            this.contadorRepeticionesBack = 0;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Se ha producido un error en el proceso.",
              life: 3000,
            });
        });
    },    
    marcaDatosKO() {
      this.previsualizadoError = true;
      this.filaPrevisualizada.previsualizadoOk = false;
      this.closeModalPrevisualizar();
      this.openModalDatosEstudiante();
    },
    marcaDatosOK() {
      this.previsualizadoError = false;
      this.filaPrevisualizada.previsualizadoOk = true;
      this.closeModalPrevisualizar();
    },
    //CURSOS-1152
    guardarDatosEstudiante() {
      let token = store.getters["token/getToken"];
      var errorDiplomaContext = {
        cursosErrorDiplomaDTO: {
          cuCod: this.filaPrevisualizada.cucod,
          identificador: this.filaPrevisualizada.identificador,
          estado: "P",
          msjEstudiante: this.errorDatosEstudiante,
          fechaSol: new Date(),
          nombreFichero: this.fichero.nombreFichero,
          fileContent: this.fichero.fileContent,
        }, //, contentType: this.fichero.type },
        pidDocumento: null,
      };

      this.servicioRest
        .guardarDatosEstudiante(errorDiplomaContext, token)
        .then((response) => {
          this.closeModalDatosEstudiante();
          this.closeModalGuardarDatos();
          this.filaPrevisualizada = null;
          if (response.accionCompletada) {
            this.$toast.add({
              severity: "success",
              summary: this.$t("error_datos_estudiante_cambio_generado"),
              detail: this.$t("error_datos_estudiante_cambio_generadoOK"),
              life: 3000,
            });
            this.$router.push({ name: "SolicitarDiploma" }),
              (this.datosEstudianteErrorSolicitaCambio = true);
            this.cargarActividades();
          } else {
            this.$toast.add({
              severity: "error",
              summary: this.$t("error"),
              detail: this.$t("error_datos_estudiante_cambio_error"),
              life: 3000,
            });
            this.datosEstudianteErrorSolicitaCambio = false;
          }
        }).catch((error) => {
            this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('soldip_datosestudanteerror'), life: 3000 });
        });
    },
    cancelarDatosEstudiante() {
      this.datosEstudianteErrorSolicitaCambio = false;
      this.closeModalPrevisualizar();
    },
    valoresDefecto() {
      this.displayModalPrevisualizar = false;
      this.previsualizadoError = false;
      this.filaPrevisualizada.previsualizadoOk = false;
    },
  },
  components: {
    DataTable,
    Column,
    Dropdown,
    Button,
    Dialog,
    pdf,
    Toast,
    Textarea,
    FicheroDiplomaError,
  },
};
</script>

